export default __webpack_public_path__ + "static/media/landing.be56bd95.jpg";